"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _luxon = require("luxon");
var _lodash = require("lodash");
var _BrixelButtonIcon = _interopRequireDefault(require("./BrixelButtonIcon"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _helper = require("../utils/helper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelBookingCard = props => {
  const {
    buyer = {},
    className = '',
    countryLang = 'ch',
    dimensionsFixed = false,
    insertBooking = false,
    onAccept,
    onAdd,
    onCancel,
    showActions = true,
    slot
  } = props;
  const [slotDay, setSlotDay] = (0, _react.useState)('');
  const [slotHour, setSlotHour] = (0, _react.useState)('');
  const buyerName = (0, _lodash.get)(buyer, 'name', null);
  const buyerEmail = (0, _lodash.get)(buyer, 'name', null);
  const buyerPhone = (0, _lodash.get)(buyer, 'name', null);
  (0, _react.useEffect)(() => {
    let date = slot.slot.split(' ')[0];
    let hour = slot.slot.split(' ')[1];
    date = _luxon.DateTime.fromSQL(date, {
      locale: countryLang
    }).toFormat('cccc - d LLLL');
    hour = `${hour} - ${parseInt(hour, 10) + 1 < 10 ? '0' : ''}${parseInt(hour, 10) + 1}:00`;
    setSlotDay(date);
    setSlotHour(hour);
  }, [slot.slot]);
  const classSize = dimensionsFixed ? 'h-fix-152 h-perc-100 w-perc-100' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-booking-card ${className} brdRadius ${classSize} shadow-1dp dis-fl-col p-1`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header dis-fl-row jc-b"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date dis-fl-col jc-c"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "info"
  }, slotDay), /*#__PURE__*/_react.default.createElement("span", {
    className: "info"
  }, slotHour), buyer && (buyerName || buyerEmail || buyerPhone) && (/*#__PURE__*/_react.default.createElement("div", {
    className: "buyer dis-fl-col mt-1"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "name"
  }, buyerName || ''), /*#__PURE__*/_react.default.createElement("span", {
    className: "email"
  }, buyerEmail || ''), /*#__PURE__*/_react.default.createElement("span", {
    className: "phone"
  }, buyerPhone ? (0, _helper.telephoneFormat)(buyerPhone) : '')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "actions"
  }, slot.status === 'pending' && !insertBooking && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col jc-b"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "question",
    color: "yellow"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-1 txtYellow400"
  }, "Request")), showActions && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-row"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "mr-1 shadow-2dp",
    theme: "red",
    themeSat: 400,
    icon: "close-small",
    onClick: () => onCancel ? onCancel() : ''
  }), /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "mr-1 shadow-2dp",
    theme: "green",
    icon: "check",
    onClick: () => onAccept ? onAccept() : ''
  }))))), slot.status === 'accepted' && !insertBooking && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col jc-b a-b"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "check",
    color: "green",
    className: "mr-small-4"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "accepted"
  }, "Accepted")), showActions && (/*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "mr-1 shadow-2dp",
    theme: "text",
    themeSat: 700,
    icon: "bin",
    onClick: () => onCancel ? onCancel() : ''
  })))), slot.status === 'canceled' && !insertBooking && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col jc-b a-b"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "rejected"
  }, "Rejected"), showActions && (/*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "mr-1 shadow-2dp",
    theme: "text",
    themeSat: 700,
    icon: "check",
    onClick: () => onAccept ? onAccept() : ''
  })))), insertBooking && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col jc-c a-b"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "shadow-2dp",
    theme: "primary",
    themeSat: 400,
    icon: "plus",
    onClick: () => onAdd ? onAdd() : ''
  }))))));
};
var _default = exports.default = BrixelBookingCard;